import {Injectable, OnDestroy} from "@angular/core"
import {
  Resolve,
  RouterStateSnapshot,
  ActivatedRouteSnapshot, Params, ActivatedRoute
} from "@angular/router"

import {Observable, of, Subscription} from "rxjs"
import {InstitutionService} from "../../services/institution.service"
import {ConfigService} from "../../services/config.service"
import {map} from "rxjs/operators"
import { ThemeColor, ThemeService } from "../../services/theme/theme.service"

@Injectable({
  providedIn: "root"
})
export class InstitutionResolver implements OnDestroy, Resolve<boolean> {

  subscriptions: Subscription = new Subscription()

  constructor(
    private institutionService: InstitutionService,
    private configService: ConfigService,
    private themeService: ThemeService
  ) { /* do nothing */ }

  resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> {

    if (this.configService.getInstitutionId()) {
      this.institutionService.getInstitution().subscribe(institution => {
        this.themeService.setTheme(institution as ThemeColor);
      })
      return of(true)
    }

    return this.recoveryInstitutionFromUrl()
  }

  recoveryInstitutionFromUrl(): Observable<boolean> {
    let institutionLinkId: string
    if (location.hostname !== "localhost") {
      institutionLinkId = location.hostname.split(".")[0]
    } else {
      institutionLinkId = "1"
    }

    return this.institutionService.getInstitutionFromInstitutionLinkId(institutionLinkId).pipe(
      map(institution => {
        this.configService.setInstitutionId(institution.id)
        this.configService.setCustomerId(institution.customerId)
        this.themeService.setTheme(institution as ThemeColor)
        return true
      })
    )
  }

  ngOnDestroy(): void {
    this.subscriptions.unsubscribe()
  }
}
